/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { cloneDeep, remove } from "lodash";
import systemAlert from "../../../utils/systemAlert";
import { viewLoading } from "../../../utils/loading";
import useForm from "../../../hooks/useForm";
import { isEmpty } from "../../../utils/lodashExtend";
import Modal, { ModalHeader } from "../../Modal";
import Icon from "../../Icon";
import Form from "../../Form";
import SingoSettingIcon from "../../../assets/images/work-schedule/work-special-icon.svg";
import { isNumber } from "../../../utils/validator";
import { isFunction } from "lodash";
import { CORPORATE_REGISTRATION_NUMBERS, TAX_SINGO_CONTACT_TYPES, TAX_SINGO_DATA_TYPE_LIST, TAX_SINGO_REPETITION_TYPE_LIST, TAX_SINGO_TAXPAYER_TYPE_LIST, TAX_SINGO_TYPE_LIST } from "../../../constants/TaxPortal/TAX_SINGO";
import { getTaxSingoRepetitionType } from "../../../utils/taxPortal/tax-singo";
import { DAY_OF_THE_WEEKS } from "../../../constants/DAY";
import { createConfiguration } from "../../../apis/tax-portal/tax-singo/tax-singo";
import { toast } from "../../../utils/toast";
import Button from "../../Button";


const defaultTaxSingoItem = {
  // idx: '', // 항목의 idx (추후 변경 및 수정을 감지하기 위한 값),
  name: '', // 항목 이름,
  description: '', // 항목 설명, 
  dataType: '', // 데이터 타입 TaxSingoType 참조
  required: '', // 필수여부 ('Y', null = 'N')
  defaultValue: '', // 기본값,
  value: '', // 값,
  order: '', // 0 (노출 순서 ),
  status: '', // 진행상태 ('pending', 'in_progress','completed', 'cancelled'),
  updatedTime: '', // 마지막 수정시간
  editEmployeeIdx: '', // 수정한 employeeIdx
  isNA: '', // 해당없음 (null = false, true, false)
}
const defaultForm = {
  name: '', //  '신고 설정 이름',
  description: '', // '신고 설정 설명',
  data: [cloneDeep(defaultTaxSingoItem)], // '신고항목에 따른 json 데이터 taxpayerSingo의 data와 맞아야 함',
  singoType: '', // '신고 유형 (예: "법인세", "부가세")'
  repetitionType: '', // '반복 타입 (daily, weekly, monthly, yearly)'
  repetitionDay: '', // '반복되는 일 (예: "1,15" = 매달 1일과 15일)'
  repetitionMonth: '', // '반복되는 달 (예: "1,3,5" = 1월, 3월, 5월)'
  reportDueOffsetDays: '1', // '반복 생성된 날로부터 신고 종료일까지의 일수',
  schedulerAdvanceDays: '-1', // '스케줄러가 신고 일정을 미리 생성하는 일수',
  targetCriteria: '', // '신고대상 지정 기준 또는 조건 (예: "법인사업자", "카드사용여부=Y")'
  reporterCriteria: '1', // '신고자 지정 기준 또는 조건 (예: "주담당자", "담당자", "지정인원")'
  specificTargets: '', // '지정 신고대상 (쉼표로 구분된 수임처 인덱스 목록)',
  specificReporters: '', //'지정 신고자 (쉼표로 구분된 담당자 인덱스 목록)
  dayOfTheWeeks: [], // 요일 선택 임시
};


const TaxSingoConfirutation = ({
  open,
  setOpen,
  mode,
  setMode,
  formData,
  setFormData,
  submit,
}) => {

  // const {
  //   taxpayerList,
  // } = useSelector(
  //   (store) => ({
  //     taxpayerList: store.Data.taxpayerList,

  //   }),
  //   shallowEqual
  // );

  const [buttons, setButtons] = useState([]);

  const reset = () => {
    setMode('create');
    resetForm(defaultForm);
  };

  const close = (e) => {
    if (e) {
      e.preventDefault();
    }
    setFormData && setFormData(null);
    setOpen(false);
    reset();
  };

  const [fields, setFields] = useState([]);
  const [checkedList, setCheckedList] = useState([]);

  const _submit = (_form) => {
    const form = cloneDeep({
      ..._form,
      data: _form.data.map((d, idx) => ({ idx, ...d })),
      reportDueOffsetDays: Number(_form.reportDueOffsetDays),
      schedulerAdvanceDays: Number(_form.schedulerAdvanceDays),
    })

    if (!isNumber(form.reportDueOffsetDays) || form.reportDueOffsetDays < 1) {
      systemAlert('"종료 일"은 양수만 가능합니다.')
      return
    }
    if (!isNumber(form.schedulerAdvanceDays)) {
      systemAlert('"생성 일"은 숫자만 가능합니다.')
      return
    }


    // 'null' === null 로 치환
    for (const key in form) {
      if (form[key] === 'null') form[key] = null
    }
    if (form.repetitionType === 'weekly') {
      form.repetitionDay = form?.dayOfTheWeeks?.join()
    }
    delete form?.dayOfTheWeeks

    if (mode === "create") {
      systemAlert(`"${form.name}" 신고설정을 등록하시겠습니까?`, {

        buttons: [
          {
            color: 'text',
            label: '취소'
          },
          {
            label: '승인',
            onClick: () => {
              viewLoading(true);
              createConfiguration(form)
                .then((res) => {
                  toast.success('등록되었습니다.');
                  close();
                  submit && submit();
                })
                .finally(() => {
                  viewLoading(false);
                });
            }
          }
        ]
      });
    } else if (mode === "modify") {
      systemAlert(`"${form.title}" 일정을 수정 하시겠습니까?`, {
        buttons: [
          {
            color: 'text',
            label: '취소'
          },
          {
            label: '승인',
            onClick: () => {

              viewLoading(true);
              // editTaxpayerSchedule(managerCompany.companyIdx, schedule.idx, form)
              //   .then((res) => {
              //     toast.success('수정되었습니다.');
              //     close();
              //     submit && submit();
              //   })
              //   .finally(() => {
              //     viewLoading(false);
              //   });
            }
          }
        ]
      });
    }
  };

  const {
    form,
    errors,
    setValidateFields,
    setForm,
    handleOnChange,
    handleSubmit,
    resetForm,
  } = useForm(
    defaultForm,
    _submit,
  );

  useEffect(() => {
    setValidateFields(fields);
  }, [fields]);

  useEffect(() => {
    !isEmpty(form) && setFields([
      {
        title: "제목",
        key: "name",
        type: "input",
        required: true,
        tooltip: <>
          반복 타입에 따라 생성될때 제목이 변경됩니다. <br /><br />
          예) 반복없음 = 입력된 제목 그대로 노출<br />
          예) 반복타입 있는 경우 = [날짜] 입력된 제목 노출
        </>
      },
      {
        title: "설명",
        key: "description",
        type: "textarea",
        height: '70px',
        minHeight: '70px',
      },
      {
        title: "신고 유형",
        key: "singoType",
        type: "select",
        options: { list: TAX_SINGO_TYPE_LIST },
        zIndex: 100,
        tooltip: "신고종류를 선택하면 해당 세금종류에 따른 별도의 스크래핑 및 기타 기능이 작동됩니다. "
      },

      {
        type: "line",
      },
      {
        title: '스케줄 설정 ',
        type: 'sub-title'
      },
      {
        title: "반복 타입",
        key: "repetitionType",
        type: "select",
        options: { list: TAX_SINGO_REPETITION_TYPE_LIST },

        onTranslator: {
          list: TAX_SINGO_REPETITION_TYPE_LIST,
        },
        zIndex: 100,
        tooltip: "반복을 선택할 경우 하단 생성되는 메뉴의 툴팁을 꼭 확인해 주세요. 매일 0~1시 기준으로 생성되며 시간은 지정할 수 없습니다.",
      },
      [
        {
          title: "요일 선택",
          key: "dayOfTheWeeks",
          type: "checkboxes",
          className: "margin-right-16",
          checkedList,
          tooltip: "요일 복수 선택 가능합니다.",
          isHide: !getTaxSingoRepetitionType(form.repetitionType)?.requiredIncludes?.includes('week'),
          required: getTaxSingoRepetitionType(form.repetitionType)?.requiredIncludes?.includes('week'),
          options: {
            list: DAY_OF_THE_WEEKS
          },
          onChange: (checked, value) => {
            let _selectedCheckboxes = [];
            if (checked) {
              _selectedCheckboxes = [...checkedList, value];
            } else {
              _selectedCheckboxes = remove(checkedList, (v) => v !== value);
            }
            setCheckedList(_selectedCheckboxes);
            setForm({ dayOfTheWeeks: _selectedCheckboxes })
          }
        },
      ],
      [

        {
          title: "선택 일",
          key: "repetitionDay",
          type: "input",
          isHide: !getTaxSingoRepetitionType(form.repetitionType)?.requiredIncludes?.includes('day'),
          required: getTaxSingoRepetitionType(form.repetitionType)?.requiredIncludes?.includes('day'),
          tooltip: "선택일을 숫자만 입력해 주세요.\n복수 일 경우 쉼표(,)로 구분 됩니다.\n예)'10,29' = 10일과 29일 ",
        },
        {
          title: "선택 월",
          key: "repetitionMonth",
          type: "input",
          isHide: !getTaxSingoRepetitionType(form.repetitionType)?.requiredIncludes?.includes('month'),
          required: getTaxSingoRepetitionType(form.repetitionType)?.requiredIncludes?.includes('month'),
          tooltip: "선택월을 숫자만 입력해 주세요.\n복수 일 경우 쉼표(,)로 구분 됩니다.\n예)'1,3' = 1월과 3월 ",
        }
      ],
      [
        {
          title: "종료 일",
          key: "reportDueOffsetDays",
          type: "number",
          required: true,
          tooltip: <>
            지정된 반복일로 부터 종료될 일자<br />
            (숫자만, 최소 1)<br /><br />
            예) 지정된 반복일 3월 20일 경우 종료일 15일 설정할 경우 4월 4일 00시 종료<br /><br />
            예) 반복 타입: 반복 없음, 종료일: 5, 금일로부터 5일뒤 종료(생성일과 관계없이 종료 일에)
          </>,
        },
        {
          title: "생성 일",
          key: "schedulerAdvanceDays",
          type: "number",
          isHide: !form.repetitionType || form.repetitionType === 'null',
          required: form.repetitionType,
          tooltip: <>
            생성 일의 기준 정보로 신고가 생성됩니다. <br />
            지정된 반복일로 부터 스케줄 생성여부<br />
            (숫자만, -마이너스 가능 )<br /><br />
            예) 지정된 반복일이 3월 20일인 경우 '생성 일' -5일 설정할 경우 3월 15일 00시 생성<br /><br />
          </>,
        },
      ],
      {
        type: "line",
      },
      ...((() => {

        const dataFieldList = []

        for (let idx = 0; idx < form.data.length; idx++) {

          if (idx !== 0) {
            dataFieldList.push({
              type: 'line',
              style: { width: '50%' }
            })
          }

          dataFieldList.push(
            {
              title: <>
                {idx + 1}번째 신고 항목&nbsp;&nbsp;{idx > 0 && <Button
                  label="삭제"
                  size="tiny"
                  color="danger"
                  onClick={() => {
                    setForm({ data: (form.data.filter((d, i) => i !== idx)) })
                  }}
                />
                }
              </>,
              type: 'sub-title'
            }
          )
          dataFieldList.push(
            [
              {
                title: '항목명',
                key: `data[${idx}].name`,
                type: 'input',
                required: true,
              },
              {
                title: "타입",
                key: `data[${idx}].dataType`,
                type: "select",
                options: { list: TAX_SINGO_DATA_TYPE_LIST },
                zIndex: 100,
                tooltip: <>
                  기본: 클릭하면 처리날짜가 저장되고 메모사용가능<br />
                  표시: 아무런 입력 없이 지정된 텍스트 표시
                </>,
              },
            ])
          dataFieldList.push(
            {
              title: '항목설명',
              key: `data[${idx}].description`,
              type: 'textarea',
              height: '50px',
              minHeight: '50px',
              tooltip: <>
                신고자에게 툴팁으로 항목 설명을 제공합니다.
              </>,
              // style: {
              //   minHeight: '50px',
              // }
            })
        }
        return dataFieldList
      })()),
      {
        type: 'button',
        label: '신고 항목 추가',
        color: 'gray-line',
        style: { width: '100%' },
        labelWidth: '0',
        isHide: mode !== 'create',
        onClick: (a, b, c) => {
          setForm({ data: [...form.data, cloneDeep(defaultTaxSingoItem)] })
        }
      },
      {
        type: "line",
      },
      {
        title: '수임처 지정',
        type: 'sub-title'
      },
      {
        title: "신고 대상",
        key: "targetCriteria",
        type: "select",
        options: { list: TAX_SINGO_TAXPAYER_TYPE_LIST },
        zIndex: 100,
        tooltip: <>폐업사업자와 수임중인 아닌 수임처는 제외됩니다.<br />
          법인,개인은 사업자등록번호 가운데자리로 구분됩니다.<br />
          법인: 가운데자리 {CORPORATE_REGISTRATION_NUMBERS.join()}</>,
      },
      {
        type: "line",
      },
      {
        title: '신고자',
        type: 'sub-title'
      },
      {
        title: "신고자",
        key: "reporterCriteria",
        type: "select",
        options: { list: TAX_SINGO_CONTACT_TYPES },
        onTranslator: {
          list: TAX_SINGO_CONTACT_TYPES,
        },
        zIndex: 100,
        tooltip: "주담당자, 담당자가 설정되지 않은 직원은 신고를 할 수 없습니다.",
      },
    ]);

  }, [form, mode, checkedList]);

  useEffect(() => {

    // 데이터 밖에서 주입받는 경우
    if (!isEmpty(formData)) {
      setForm({
        ...formData,
      });
    }

    setMode(mode);
    if (mode === "create" || mode === "modify") {
      setButtons([
        {
          label: "닫기",
          color: 'text',
          onClick: close
        },
        {
          label: mode === "create" ? "생성하기" : "수정",
          onClick: handleSubmit,
        },
      ]);
    } else if (mode === "view" && isFunction(setMode)) {
      setButtons([
        {
          label: "닫기",
          color: 'text',
          onClick: close,
        },
        // {
        //   label: "수정 화면 이동",
        //   onClick: () => {
        //     setMode("modify");
        //     setIsModeChange(true);
        //   }
        // },
      ]);
    }
  }, [formData, mode]);


  return (
    <Modal
      isOpen={open}
      close={close}
    >
      <div className="client-write">
        <ModalHeader>
          <Icon
            style={{ verticalAlign: 'top' }}
            src={SingoSettingIcon}
            width="40px"
            height="40px"
          />&nbsp;
          신고설정 {mode === 'create' && "생성"}
          <small style={{ display: 'block', fontSize: '12px' }}>각 항목의 툴팁을 꼭 확인하여 사용법을 숙지 해주세요.</small>
        </ModalHeader>
        <Form
          mode={mode}
          isRequiredShow={true}
          fields={fields}
          form={form}
          onChange={handleOnChange}
          // submit={handleSubmit}
          // cancelText={'닫기'}
          // cancel={close}
          errors={errors}
          buttons={buttons}
        />
      </div>
    </Modal>
  );
};


export default TaxSingoConfirutation;
